import { useFormik } from "formik";
import React, { useRef, useState} from "react";

import { BsSearch, BsUpload } from "react-icons/bs";
import { IoIosClose } from "react-icons/io";
import * as yup from "yup";
import { uploadAudiService } from "../../services/audioServices";
import ClipLoader from "react-spinners/ClipLoader";
// import { rootContexts } from "../../contexts/rootContexts";
// import { scroller } from 'react-scroll';

import contribute from "../../assets/images/contribute/contribute.png";
import errorModel from "../Errors/ErrorModel";
export default function ContributeSection() {
  const fileInputRef = useRef(null);

  const [detect, setDetectBtn] = useState(false);
  const [fileName, setFileName] = useState("");
  const [loader, setLoader] = useState(false);
  const [filetype, setFiletype] = useState(""); 
  // const {setAudioResult}= useContext(rootContexts)
  // const scrollToResult = () => {
  //   scroller.scrollTo('result', {
  //     offset:200,
  //     duration:500,
  //     delay: 50,
  //     smooth: 'easeInOutQuart'
  //   });
  // };

  const formik = useFormik({
    initialValues: {
      audio:[],
      audPurpose: "Contribution",
  
    },
    validationSchema: yup.object({
      audio: yup.mixed().required('required')
    }),
    onSubmit: async (values) => {
      setLoader(true);

      const result = await uploadAudiService(values);
      if(filetype === "mp3"){
        setTimeout(() => {
          setLoader(false);
          setLoader(false);
          setDetectBtn(false);
          errorModel("success", "Thank you for contributing to the success of our service.");
          // scrollToResult();
          formik.resetForm();
          setDetectBtn(false); 
          
           fileInputRef.current.value=""
        }, 3000);
        console.log("the reslut is ", result);
      }else{
        setTimeout(() => {
          setLoader(false);
          setLoader(false);
          setDetectBtn(false);
          errorModel("error", `Invalid audio format, please
          provide an audio file with the supported format`);
          formik.resetForm();
          setDetectBtn(false); 
          
           fileInputRef.current.value=""
        }, 3000);
        console.log("the reslut is ", result);
      }
      // if(result.status){
      //   setLoader(false);
      //   setAudioResult(true)
      //   setDetectBtn(false);
      //   errorModel('success',result.message)
      // }
      // else{
      //   setLoader(false);
      //   setAudioResult(false)
      
      //   errorModel('error',result.message)
      // }
     
    },
  });
  const filehandler = (e) => {
   

    formik.setFieldValue('audio', e.target.files[0]);
    const Fileset = e.target.files[0];
    if (Fileset && Fileset.name.endsWith(".mp3")) {
      setFiletype('mp3')
    }else{
      setFiletype('mpall')
    }
    setFileName(e.target.files[0].name);
   
    setDetectBtn(true);
  };
  const detectHandler=()=>{
    formik.resetForm();
    setDetectBtn(false); 
    
     fileInputRef.current.value=""
    
  }

  return (
    <>
      <div className="py-20 bg-[#D7C0AE80]" id="contribute">
        <div className="container px-2 md:px-20 m-auto ">
          <div className="grid grid-cols-1 md:grid-cols-2 py-20 items-center">
            <div className="px-2 md:px-5 space-y-5 relative before:absolute before:right-0 before:h-full before:w-[1px] before:bg-beta">
              <img
                src={contribute}
                className="w-full h-1/2 rounded-sm"
                alt=""
              />
            </div>
            <div className="space-y-8 px-2 md:px-20 bg-white h-full flex flex-col items-center justify-center">
              <h1 className="h1">Contribute</h1>
              <p className="p">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore et dolore magna aliqua. In
                eu mi bibendum neque egestas congue. Lorem ipsum dolor sit amet,
                consectetur adipiscing elit, sed do eiusmod tempor incididunt ut
                labore et dolore magna aliqua. In eu mi bibendum neque egestas
                congue.
              </p>
              <div>
              <form onSubmit={formik.handleSubmit}>
                <div>
                  
                <input
                  type="file"
                  name="audio"
                  onChange={filehandler}
                  ref={fileInputRef}
                  accept="audio/*"
                  className="hidden w-full h-10"
                  onBlur={formik.handleBlur}
                  />

                  </div>
                {detect ? (
                  <div>
                  <div className="flex gap-x-4 items-center justify-between">
                    <p className="p flex py-3 items-center gap-x-3 ">
                      {fileName}{" "}
                      <IoIosClose className="mt-1 cursor-pointer text-2xl"
                      onClick={()=>{detectHandler();}}
                      />{" "}
                    </p>
                    {formik.touched.audio && formik.errors.audio && (
          <div className=" pt-3 text-[12px] text-red-600 font-imprima">
           {formik.errors.audio}
          </div>
        )}
                    <button
                      type="submit"
                    
                      className="btn-warning"
                      disabled={loader}
                    >
                      Contribute 
                      {loader ?
                      <ClipLoader
        color={"#ffffff"}
        loading={true}
        // cssOverride={override}
        size={15}
        className="relative top-1 left-2"
        aria-label="Loading "
        data-testid="loader"
      />
      :
                      <BsSearch className="text-[#394C34] mt-1" /> }

                    </button>
                  </div>
                
                  </div>
                ) : (
                  <button
                    type="button"
                    onClick={() => {
                      fileInputRef.current.click();
                    }}
                    className="btn-primary"
                  >
                    Upload <BsUpload className="text-white " />{" "}
                  </button>
                )}
              </form>
              
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
